<template>
  <div class="box-tuning-container">
    <div v-if="sender === 'customer' && showQc">
      <!-- speech -->
      <div class="m-t-30">
        <v-row class="ml-0 mr-0">
          <v-col cols="2">
            <b>Speech</b>
          </v-col>
          <v-col cols="3">
            Valid speech
          </v-col>
          <v-col cols="7">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :class="qc.speech.status === 'ok' ? 'icon-success' : ''"
                  @click="clickValidSpeech(qc, 'ok')"
                >
                  {{
                    qc.speech.status === 'ok'
                      ? 'fa-check-circle'
                      : 'far fa-check-circle'
                  }}
                </v-icon>
              </template>
              <span>Valid speech</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :class="qc.speech.status === 'not_ok' ? 'icon-danger' : ''"
                  class="m-l-5"
                  @click="clickValidSpeech(qc, 'not_ok')"
                >
                  {{
                    qc.speech.status === 'not_ok'
                      ? 'fa-times-circle'
                      : 'far fa-times-circle'
                  }}
                </v-icon>
              </template>
              <span>Invalid speech</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-if="qc.speech.status === 'not_ok'" class="ml-0 mr-0">
          <v-col cols="3" offset="2">
            Reasons
          </v-col>
          <v-col cols="7">
            <v-select
              :id="`speech-reason-${index}`"
              v-model="qc.speech.reason"
              class="no-margin"
              :items="$qcReason"
              hide-details
              dense
              @blur="blurSpeechReason"
            ></v-select>
          </v-col>
        </v-row>
      </div>

      <!-- asr -->
      <div
        v-if="
          qc.speech.status === 'ok' ||
            (qc.speech.status === 'not_ok' &&
              qc.speech.reason === 'Out of scope')
        "
        class="m-t-15"
      >
        <v-row class="ml-0 mr-0">
          <v-col cols="2">
            <b>ASR</b>
          </v-col>
          <v-col cols="3">
            Grammar
          </v-col>
          <v-col cols="7">
            {{ qc.asr.grammar || '-' }}
          </v-col>
        </v-row>
        <v-row class="ml-0 mr-0">
          <v-col cols="3" offset="2">
            Prediction
          </v-col>
          <v-col cols="7" class="word-wrap">
            {{ qc.asr.prediction }}
          </v-col>
        </v-row>
        <v-row class="ml-0 mr-0">
          <v-col cols="3" offset="2">
            Expected
          </v-col>
          <v-col cols="7">
            <v-textarea
              v-model="qc.asr.expected"
              class="textarea-input"
              rows="3"
              solo
              dense
              hide-details
              @keydown="asrWordAcc(qc.asr.prediction, qc.asr.expected)"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row class="ml-0 mr-0">
          <v-col cols="3" offset="2">
            Word Acc
          </v-col>
          <v-col cols="7">{{
            qc.asr.word_acc ? `${parseFloat(qc.asr.word_acc).toFixed(2)}%` : '-'
          }}</v-col>
        </v-row>
      </div>

      <!-- intent -->
      <div v-if="qc.speech.status === 'ok'" class="m-t-15">
        <v-row class="ml-0 mr-0">
          <v-col cols="2">
            <b>Intent</b>
          </v-col>
          <v-col cols="3">
            Prediction
          </v-col>
          <v-col cols="4">
            <div>{{ qc.intent.prediction || '-' }}</div>
          </v-col>
          <v-col cols="3" class="text-right">
            <div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    :class="qc.intent.status === 'ok' ? 'icon-success' : ''"
                    @click="
                      qc.intent.status === 'ok'
                        ? (qc.intent.status = '')
                        : (qc.intent.status = 'ok')
                    "
                  >
                    {{
                      qc.intent.status === 'ok'
                        ? 'fa-check-circle'
                        : 'far fa-check-circle'
                    }}
                  </v-icon>
                </template>
                <span>Correct prediction</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    :class="qc.intent.status === 'not_ok' ? 'icon-danger' : ''"
                    class="m-l-5"
                    @click="
                      qc.intent.status === 'not_ok'
                        ? (qc.intent.status = '')
                        : (qc.intent.status = 'not_ok')
                    "
                  >
                    {{
                      qc.intent.status === 'not_ok'
                        ? 'fa-times-circle'
                        : 'far fa-times-circle'
                    }}
                  </v-icon>
                </template>
                <span>Incorrect prediction</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    :class="
                      qc.intent.status === 'not_sure' ? 'icon-warning' : ''
                    "
                    class="m-l-5"
                    @click="
                      qc.intent.status === 'not_sure'
                        ? (qc.intent.status = '')
                        : (qc.intent.status = 'not_sure')
                    "
                  >
                    {{
                      qc.intent.status === 'not_sure'
                        ? 'fa-question-circle'
                        : 'far fa-question-circle'
                    }}
                  </v-icon>
                </template>
                <span>Not sure</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
        <v-row
          v-if="
            qc.intent.status === 'not_ok' || qc.intent.status === 'not_sure'
          "
          class="ml-0 mr-0 m-b-10"
        >
          <v-col cols="3" offset="2">
            Expected
          </v-col>
          <v-col cols="7">
            <v-combobox
              v-model="qc.intent.expected"
              :items="intents"
              item-text="name"
              item-value="name"
              :return-object="false"
              class="no-margin"
              hide-details
              dense
              @keyup="enterItem"
              @change="selectIntentExpected"
              @blur="setupIntentExpected"
            ></v-combobox>
          </v-col>
        </v-row>
      </div>

      <!-- remark -->
      <div class="m-t-15">
        <v-row class="ml-0 mr-0">
          <v-col cols="2">
            <b>Remark</b>
          </v-col>
          <v-col cols="7" offset="3">
            <v-textarea
              v-model="qc.remark"
              class="textarea-input"
              rows="3"
              solo
              dense
              hide-details
            ></v-textarea>
          </v-col>
        </v-row>
      </div>
    </div>

    <!--<div v-else>
      <v-row class="ml-0 mr-0">
        <v-col cols="4">
          Valid response
        </v-col>
        <v-col cols="8">
          <v-icon
            :class="qc.speech.status === 'ok' ? 'icon-success' : ''"
            @click="qc.speech.status = 'ok'"
          >
            {{
              qc.speech.status === 'ok'
                ? 'fa-check-circle'
                : 'far fa-check-circle'
            }}
          </v-icon>
          <v-icon
            :class="qc.speech.status === 'not_ok' ? 'icon-danger' : ''"
            class="m-l-5"
            @click="qc.speech.status = 'not_ok'"
          >
            {{
              qc.speech.status === 'not_ok'
                ? 'fa-times-circle'
                : 'far fa-times-circle'
            }}
          </v-icon>
        </v-col>
      </v-row>
      <v-row v-if="qc.speech.status !== 'ok'" class="ml-0 mr-0">
        <v-col cols="4">
          Reasons
        </v-col>
        <v-col cols="8">
          <v-radio-group
            v-model="qc.speech.reason"
            class="m-t-0"
            row
            dense
            hide-details
          >
            <v-radio
              v-for="(reason, index) in reasons"
              :key="index"
              :label="reason"
              :value="reason"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row class="ml-0 mr-0">
        <v-col cols="4">
          Remark
        </v-col>
        <v-col cols="8">
          <v-textarea
            v-model="qc.remark"
            class="textarea-input"
            label="Description"
            rows="3"
            solo
            dense
            hide-details
          ></v-textarea>
        </v-col>
      </v-row>
    </div>-->
  </div>
</template>

<script>
import _ from 'lodash'
import apiIntent from '@/apis/intent'
import apiConversation from '@/apis/conversation'

export default {
  props: {
    channel: String,
    conversation: Object,
    intents: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: Number
  },
  watch: {
    conversation: {
      deep: true,
      immediate: true,
      async handler(val) {
        this.sender = val.sender
        this.showQc = val.message && !val.message.utterance.includes('NO-INPUT')

        if (!val.qc && this.channel === 'voice') {
          if (this.sender === 'customer') {
            let prediction = val.message.utterance || ''
            const item = _.find(val.bot_item, {
              conversation_id: val.conversation_id
            })
            if (item && item.payload && item.payload.raw)
              prediction = item.payload.raw

            const expected = val.message.utterance || ''
            const wordAcc = await this.calcAccuracy(prediction, expected)

            val.qc = {
              speech: {
                status: '',
                reason: ''
              },
              asr: {
                grammar: val.grammar || '',
                // prediction: val.message.utterance || '',
                prediction,
                expected,
                word_acc: wordAcc
              },
              intent: {
                status: '',
                prediction: val.intent || '',
                expected: ''
              },
              remark: ''
            }
          }
        }

        this.qc = val.qc
      }
    }
  },
  data() {
    return {
      reasons: ['Wrong response or answer', 'Unnatural response'],
      sender: '',
      showQc: false,
      qc: {
        speech: {
          status: '',
          reason: ''
        },
        asr: {
          grammar: '',
          prediction: '',
          expected: '',
          word_acc: ''
        },
        intent: {
          status: '',
          prediction: '',
          expected: ''
        }
      },
      intentInput: ''
    }
  },
  methods: {
    async calcAccuracy(predict, expected) {
      try {
        const getWordAccuracy = await apiConversation.getWordAccuracy({
          predict,
          expected
        })
        const { data } = getWordAccuracy
        return data.accuracy
      } catch (error) {}
    },
    async asrWordAcc(predict, expected) {
      const acc = await this.calcAccuracy(predict, expected)
      this.qc.asr.word_acc = acc
    },
    enterItem(e) {
      this.intentInput = e.target.value
    },
    selectIntentExpected() {
      this.intentInput = this.qc.intent.expected
    },
    setupIntentExpected() {
      this.qc.intent.expected = this.intentInput
    },
    clickValidSpeech(qc, status) {
      qc.speech.status === status
        ? (qc.speech.status = '')
        : (qc.speech.status = status)

      if (qc.speech.status === 'not_ok' && !qc.speech.reason) {
        setTimeout(() => {
          const id = document.getElementById(`speech-reason-${this.index}`)
          if (id) {
            id.focus()
            id.click()
          }
        }, 100)
      }
    },
    blurSpeechReason() {
      if (!this.qc.speech.reason) this.qc.speech.reason = 'Other'
    }
  }
}
</script>
<style scoped lang="scss">
.col {
  padding: 3px 0;
}

.box-tuning-container {
  padding: 0 5px 5px 5px;
  margin-top: -15px;
  font-size: 14px;
}
.no-margin {
  margin-top: -5px !important;
}

.word-wrap {
  word-wrap: break-word;
}
</style>
